import './highlight-overview.scss';
import { findAll, onBlockRender, once } from '../../global/utils/acf-preview';

// Click-to-play: swap the poster for the embedded video (from the <template>),
// adding autoplay so it starts on the first click.
function initVideo( media: HTMLElement ): void {
	if ( ! once( media, 'HighlightVideo' ) ) {
		return;
	}
	const button = media.querySelector<HTMLButtonElement>( '.highlight-overview__play' );
	const template = media.querySelector<HTMLTemplateElement>( '.highlight-overview__embed' );
	if ( ! button || ! template ) {
		return;
	}

	button.addEventListener( 'click', () => {
		const fragment = template.content.cloneNode( true ) as DocumentFragment;
		const iframe = fragment.querySelector( 'iframe' );
		if ( iframe ) {
			const src = iframe.getAttribute( 'src' ) || '';
			iframe.setAttribute( 'src', src + ( src.includes( '?' ) ? '&' : '?' ) + 'autoplay=1' );
			iframe.setAttribute( 'allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media' );
		}
		// A self-hosted <video> upload: start playback on reveal.
		const video = fragment.querySelector<HTMLVideoElement>( 'video' );
		media.appendChild( fragment );
		media.classList.add( 'is-playing' );
		if ( video ) {
			void video.play?.();
		}
	}, { once: true } );
}

onBlockRender( 'highlight-overview', ( root ) => {
	findAll<HTMLElement>( root, '.highlight-overview__media[data-video-embed]' ).forEach( initVideo );
} );
